import { useContext } from 'react'
import BreakpointContext from 'src/context/BreakpointContext'
import { TypeBreakpointContent } from 'src/@types/Breakpoint'
const useRWD = () => {
    return useContext(BreakpointContext) as TypeBreakpointContent
}

export default useRWD
